const addScript = () => {
    const element = document.createElement("script");
    element.src =
        "https://cdn-cookieyes.com/client_data/a66c0dc7dd2f247ca7c70a37/script.js";
    element.id = "cookieyes";
    element.type = "text/javascript";
    document.head.appendChild(element);
};

const setupCookieyes = () => {
    if (window.location.href.indexOf("softwaremill.com") > -1) {
        addScript();
    }
};

export default setupCookieyes;
